import React from 'react';
import s from './Hero.module.css';
import Ribbon from '../../Ribbon/Ribbon';

function Hero({ navLogo, background }) {
  return (
    <section className={s.hero}>
      <div
        className={s.div}
        style={{
          background: `url(${background})`,
          backgroundRepeat: `no-repeat`,
        }}
      >
        <div className={s.nav}>
          <ul className={s.list}>
            <li className={s.item}>{navLogo}</li>
            <li className={s.item}>
              <a href="#gallery" className={s.link}>
                Галерея
              </a>
            </li>
            <li className={s.item}>
              <a href="#features" className={s.link}>
                Опис
              </a>
            </li>
            <li className={s.item}>
              <a href="#characteristics" className={s.link}>
                Характеристики
              </a>
            </li>
            <li className={s.item}>
              <a href="#store" className={s.link}>
                Де купити
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={s.ribbon}>
        <Ribbon />
      </div>
    </section>
  );
}

export default Hero;
